import { ArtistType } from '@api';
import {
  ContactPersonAnchor,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';
import { ArtistContactsTableRowType } from '../../types';

type ArtistContactsTableRowPropsType = {
  artist: ArtistType;
  row: ArtistContactsTableRowType;
};

export const ArtistContactsTableRow: React.FC<
  ArtistContactsTableRowPropsType
> = ({ artist, row }) => {
  const { t } = useTranslation('artistDetailsGeneral');

  const value = artist[row.accessor];

  const renderValue = () => {
    if (!value) return t('NO_DATA_PLACEHOLDER', { ns: 'common' });
    return <ContactPersonAnchor contactPerson={value} />;
  };

  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>
        {t(`CONTACTS.ROWS.${row.label}`)}
      </TouringCardTableRowLabel>
      <TouringCardTableRowValue>{renderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
